<template>
	<div>
		<b-card no-body >
			<div class="row mt-3 mb-3 pl-4">
				<div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
					
					<h2><i class="fa fa-arrow-left" @click="$router.go(-1)" style="cursor:pointer"></i><span class="ml-3">Estimasi</span></h2>
				</div>
			</div>
		</b-card>

		<div v-if="woDetail && woFull && woFull.deleted_at" class="text-center">
			<h4 style="color:red">Work Order Ini Telah Dibatalkan.</h4>
		</div>

		<b-card no-body  class="pt-2 pb-2 mt-2">
			<div class="row">
				<div class="col-md-2 flex-center" v-if="!mobile">
					<i class="fa fa-chevron-left" style="font-size:90px;" @click="changeWorkOrder('<')"></i>
				</div>
				<div class="col-md-8  col-12 flex-center" :class="{ 'mb-4 offset-md-2': mobile }">
					<div v-if="woDetail">
						<img
							:src="env.baseImage + '/' + woDetail.image"
							style="max-height:250px; width:auto;max-width:100%;min-height:400px"
							
							alt="No Image"
						/>
					</div>
					<h4 v-else class="text-center">No Image Available</h4>
				</div>
				<div class="col-md-2 flex-center">
					<i class="fa fa-chevron-right" style="font-size:90px;" @click="changeWorkOrder('>')"></i>
				</div>
			</div>
		</b-card>
		<!-- <hr> -->
		<div
			class="row mt-2"
			v-if="woDetail"
			:class="{ cancelled: woFull && woFull.deleted_at }"
		>
			<div class="col-md-7 pr-3 h-100">
				<b-card no-body class="p-10">
					<div class="row pr-2">
						<div class="col-8 mt-auto mb-auto">
							<h4 class="mt-2 ml-2 mr-2" style="text-decoration-line: underline;text-underline-offset: 6px;">{{woDetail.tipe}}</h4>
						</div>
						<div class="col-4 mt-auto mb-auto">
							<button
								class="btn btn-primary w-100"
								@click="
									woFull.version > 1 ?
									$router.push(
										`/work-order-detail/v${woFull.version}/wo?wo=${form_code}`
									)
									:
									$router.push(
										`/work-order-detail/wo?wo=${form_code}`
									)
								"
							>
								Cek Pengerjaan WO
							</button>
						</div>
					</div>
					
					<div class="row mb-4 mt-3 pb-1 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Work Order ID
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.show_wo
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Mesin
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_mesin
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Rangka
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_rangka
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Polisi
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_polisi
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tipe
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tipe
									}}</b>
								</div>
							</div>

						</div>
						<div class="col-md-6" style="font-size:14px">
							<div class="row">
								<div class="col-5 mt-1">
									Tanggal Masuk
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tanggal_masuk
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Pelanggan
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.pelanggan
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Nama Alias
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woDetail.customer && woDetail.customer.alias ? woDetail.customer.alias : '-'}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									CSO
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.cso
									}}</b>
								</div>
							</div>
							
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tahun
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tahun
									}}</b>
								</div>
							</div>
							<!-- <table class="wo-stats">
								<tr>
									<th>Tanggal Masuk:</th>
									<td>{{ woDetail.tanggal_masuk }}</td>
								</tr>
								<tr>
									<th>Pelanggan:</th>
									<td>{{ woDetail.pelanggan }}</td>
								</tr>
								<tr>
									<th>CSO:</th>
									<td>{{ woDetail.cso }}</td>
								</tr>
								<tr>
									<th>Merek:</th>
									<td>{{ woDetail.merek }}</td>
								</tr>
								<tr>
									<th>Tahun:</th>
									<td>{{ woDetail.car.year }}</td>
								</tr>
							</table> -->
						</div>
					</div>

				</b-card>
			</div>
			<div class="col-md-5">
				<b-card no-body>
					<div>
						<div class="w-100 mt-2 pb-3" style="margin-left:12px">
							<div class="row pr-4">
								<div class="col-7 mt-auto mb-auto">
									<h4 style="text-decoration-line: underline;text-underline-offset: 6px;">Detail Pricelist</h4>
								</div>

								<div class="col-5 mt-auto mb-auto">
									<button
										class="btn btn-info w-100"
										@click="$set(modal , 'setPrice' , true)"
									>
										Ubah Harga Mobil
									</button>
								</div>
							</div>
							
							<!-- <table class="table table-borderless">
								<tr>
									<th>Harga Mobil:</th>
									<td>Rp {{ woDetail.price ? numberWithCommas(woDetail.price) : '-' }}
									</td>
								</tr>
								<tr>
									<th>Kategori Pricelist</th>
									<td v-if="woDetail.price">{{priceCondition}} <br> {{priceConditionText}}</td>
									<td v-else>-</td>
								</tr>
							</table> -->
							<div class="mt-3">
								<div class="row">
									<div class="col-4 mt-1">
										<h5>Harga Mobil</h5>
									</div>
									<div class="col-md-1 mt-1">
										:
									</div>
									<div class="col-7 mt-1">
										Rp
										{{
											woDetail.price
												? numberWithCommas(woDetail.price)
												: "-"
										}}
									</div>
								</div>
								<div class="row">
									<div class="col-4 mt-1">
										<h5>Kategori</h5>
									</div>
									<div class="col-md-1 mt-1">
										:
									</div>
									<div class="col-7 mt-1" v-if="woDetail.price">
										{{ priceCondition }} <br />
										
									</div>
									<div class="col-6 mt-1" v-else>-</div>
									
								</div>
								<div class="row">
									<div class="col-5"></div>
									<div class="col-7">
										{{ priceConditionText }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-card>
				<b-card no-body class="mt-2">
					<div>
						<div
							class="w-100 mt-3 pb-3"
							style="padding-left:12px"
							v-if="showStatistics"
						>
							<h4 style="text-decoration-line: underline;text-underline-offset: 6px;">Statistik Work Order</h4>
							<div class="mt-3">
								<div class="row w-100">
									<div class="col-6 mt-1">
										<h5>Harga Beli Sparepart:</h5>
										<!-- <span class="td"
											>( Sparepart Yang Dibeli Oleh Bengkel
											)</span
										> -->
									</div>
									<div class="col-6 mt-1">
										Rp
										{{
											numberWithCommas(
												totalSparepartPurchasePrice
											)
										}}
									</div>
								</div>
								<div class="row w-100 bahanTab" @click="bahanUsageList">
									<div class="col-6 mt-1 ">
										<h5>Harga Pemakaian Bahan:</h5>
										<!-- <span class="td"
											>( Sparepart Yang Dibeli Oleh Bengkel
											)</span
										> -->
									</div>
									<div class="col-6 mt-1 ">
										Rp
										{{
											estimationData ?
											numberWithCommas(
												estimationData.resultBahanUsage
											)
											: 'Loading....'
										}}
									</div>
								</div>
								<div class="row w-100">
									<div class="col-6 mt-1 ">
										<h5>Harga Pemakaian Cat:</h5>
										<!-- <span class="td"
											>( Sparepart Yang Dibeli Oleh Bengkel
											)</span
										> -->
									</div>
									<div class="col-6 mt-1 ">
										Rp
										{{
											estimationData ?
											numberWithCommas(
												estimationData.details.catPrice
											)
											: 'Loading....'
										}}
									</div>
								</div>
								<div class="row w-100">
									<div class="col-6 mt-1">
										<h5>Net Profit:</h5>
										<!-- <span class="td"
											>( Net Total + Own Risk - Harga Beli
											Sparepart )</span
										> -->
									</div>
									<div class="col-6 mt-1" v-if="woDetail.price && estimationData">
										Rp.
										{{
											numberWithCommas(
												parseFloat(
													calculateTotal(1)
														.split(",")
														.join("")
												) +
													parseFloat(
														estimationData.details
															.own_risk
													) -
													totalSparepartPurchasePrice
													- estimationData.resultBahanUsage
											)
										}}<br />
									</div>
									<div class="col-6 mt-1" v-else>-</div>
								</div>
							</div>
						</div>
					</div>
				
				</b-card>
			</div>
		</div>

		<!-- <b-card no-body class="mt-2 p-10">
			<h6>Opsi Work Order</h6>
			<div class="row">
				<div class="col-md col-6 mt-1">
					<button
						class="btn btn-primary w-100"
						@click="
							woFull.version > 1 ?
							$router.push(
								`/work-order-detail/v${woFull.version}/wo?wo=${form_code}`
							)
							:
							$router.push(
								`/work-order-detail/wo?wo=${form_code}`
							)
						"
					>
						Cek Pengerjaan WO
					</button>
				</div>
				<div class="col-md col-6 mt-1">
					<button
						type="button"
						class="btn btn-warning w-100"
						@click="changeWorkOrder('<')"
					>
						Previous Work Order
					</button>
				</div>
				<div class="col-md col-6 mt-1">
					<button
						type="button"
						class="btn btn-success w-100"
						@click="changeWorkOrder('>')"
					>
						Next Work Order
					</button>
				</div>
			</div>
		</b-card> -->

		<!-- Detail Asuransi dan Status Work Order -->
		<b-card no-body class="mt-2 p-10">
		<div class="row w-100" :class="{ cancelled: woFull && woFull.deleted_at }">
			<div class="col-md-6 col-12">
				
					<div class="w-100 pl-2 pr-2 mt-3">
						<h4 class="text-decor-line">Detail Asuransi</h4>
						<div
							style="display:block;overflow-x:scroll"
							v-if="
								woDetail &&
									estimationData &&
									estimationData.details.insurance_id == null
							"
						>
							<table class="table text-center mt-3">
								<thead>
									<th>No.</th>
									<th>Policy Number</th>
									<th>Company</th>
									<th>Expiry Date</th>
									<th><i class="fa fa-cog"></i></th>
								</thead>
								<tbody
									v-for="(asuransi, index) in woDetail.asuransi"
									:key="asuransi.policy_number"
								>
									<tr>
										<td class="vert-aligned">
											{{ index + 1 }}
										</td>
										<td class="vert-aligned">
											{{ asuransi.policy_number }}
										</td>
										<td class="vert-aligned">
											{{ asuransi.insuranceCompany.name }}
										</td>
										<td class="vert-aligned">
											{{ asuransi.policy_expiry }}
										</td>
										<td>
											<button
												v-if="
													moment(asuransi.policy_expiry) >
														moment()
												"
												class="btn btn-primary"
												type="button"
												@click="
													updateInsuranceEstimation(
														asuransi.id
													)
												"
											>
												Select
											</button>
											<h6 v-else style="color:red">
												Polis Kadaluarsa
											</h6>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="row">
								<div class="col col-md-5">
									<button
										type="button"
										class="btn btn-info w-75"
										@click="showAddModal = true"
									>
										Tambah Asuransi
									</button>
								</div>
								<div
									class="col col-md-5"
									v-if="woDetail.asuransi.length <= 0"
								>
									<button
										type="button"
										class="btn btn-warning w-75"
										@click="newAsuransi('Umum')"
									>
										Tambah Umum
									</button>
								</div>
							</div>
						</div>
						<div
							v-else-if="
								woDetail &&
									estimationData &&
									estimationData.details.insurance_id != null
							"
						>
							<table
								class="table table-borderless"
								v-if="insuranceDetails"
							>
								<tbody>
									<tr>
										<td>Nomor Polis</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{ insuranceDetails.policy_number }}
										</td>
									</tr>
									<tr>
										<td>Nama Representatif Polis</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{ insuranceDetails.insured_name }}
										</td>
									</tr>
									<tr>
										<td>Tanggal Kadaluarsa</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{
												moment(
													insuranceDetails.policy_expiry
												).format("DD MMM Y")
											}}
										</td>
									</tr>
									<tr>
										<td>Perusahaan Asuransi</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{
												insuranceDetails.insuranceCompany
													.company_name
											}}
										</td>
									</tr>
									<tr>
										<td>Alamat Perusahaan Asuransi</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{
												insuranceDetails.insuranceCompany
													.address
											}}
										</td>
									</tr>
									<tr>
										<td>Jumlah TPL</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											Rp . {{ numberWithCommas(insuranceDetails.tpl) }} <span v-if="insuranceDetails.tpl == 0">(Tidak Ada Limit)</span>
										</td>
									</tr>
									<tr>
										<td>Dokumen Polis Mobil</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											<button
												class="btn btn-info"
												@click="
													openDocument(
														insuranceDetails.document
													)
												"
											>
												Liat Dokumen
											</button>
										</td>
									</tr>
									<tr v-if="estimationData.details.no_spk">
										<td>Nomor SPK</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{ estimationData.details.no_spk }}
										</td>
									</tr>
									<tr v-if="insuranceDetails.tpl_cover">
										<td>TPL Coverage</td>
										<td>:</td>
										<td class="vert-aligned" style="font-weight:bold;">
											{{ insuranceDetails.tpl_cover.form_source }} - {{insuranceDetails.tpl_cover.nomor_polisi}}<br>Coverage Up To Rp. {{ numberWithCommas(insuranceDetails.tpl_cover.limit) }}
										</td>
									</tr>
									<tr>
										<td :colspan="3">
											<div class="row">
												<div class="col-md-4 col-12">
													<button
														@click="changePolicy(null)"
														type="button"
														class=" w-100 btn btn-warning"
													>
														Ganti Polis Asuransi
													</button>
												</div>
												<div class="col-md-4 col-12">
													<button
														@click="showTPLModal"
														type="button"
														class=" w-100 btn btn-success"
														v-if="!insuranceDetails.tpl_cover"
													>
														Input TPL Asuransi
													</button>
													<button
														@click="removeTPL"
														type="button"
														class=" w-100 btn btn-danger"
														v-else
													>
														Hilangkan TPL Asuransi
													</button>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-center" v-else>
							<h4>Loading....</h4>
						</div>
					</div>
				
				</div>

				<!-- End Insurance -->
				<div class="col-md-6 col-12">
					<div class="w-100 pl-2 pr-2 mt-3">
						<h4 class="text-left text-decor-line">Status Work Order</h4>
						<table
							class="table text-center mt-3 border "
							style="color:black"
						>
							<thead class="thead-dark">
								<th>Status</th>
								<th></th>
								<th>Tanggal Penyelesaian</th>
							</thead>
							<tbody
								v-for="text in statusText"
								class="mt-1"
								:key="text.name"
							>
								<tr :class="{ redStatus: recentLog == text.name }">
									<td>
										<span v-if="text.name == 'Pembayaran' && (text.value && text.value != '-')" @click="goToPembayaran()">
											<i class="fa fa-eye fa-lg"></i>
										</span>
										{{ text.name }}
									</td>
									<td>:</td>
									<!-- <td>{{woLog.map((x) => return {id:x.id, name:x.customer.name})}}</td> -->
									<td>
										{{
											text.value == null || text.value == "-"
												? text.value
												: moment(text.value).format(
														"MMMM DD, Y HH:mm"
												)
										}}

										
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</b-card>

		<div v-if="pending_estimation.length > 0" class="row mt-3 w-100">
			<div class="col-12">
				<h4>Pending Estimation</h4>

				<table class="table">
					<thead>
						<th>No.</th>
						<th>Nama Sparepart</th>
						<th>Deskripsi</th>
						<th>Jumlah</th>
						<th>Waktu Datang</th>
						<th><i class="fa fa-cog"></i></th>
					</thead>
					<tbody v-for="(dat , index) in pending_estimation">
						<tr>
							<td>{{index + 1}}</td>
							<td>{{dat.sparepart_name}}</td>
							<td>{{dat.description}}</td>
							<td>{{dat.amount}}</td>
							<td>{{moment(dat.waktu_datang).format('MMM DD,Y HH:mm')}}</td>
							<td><button class="btn btn-primary" @click="mergePending(dat)">Isi Data</button></td>
						</tr>
					</tbody>
				</table>
			</div>
			
		</div>

		<!-- Estimator Table -->
		<div
			class="mt-2 w-100"
			style="min-width:310px"
			v-if="estimationData && !reloadTable"
			:class="{ cancelled: woFull && woFull.deleted_at }"
		>
			<div class="row">
				<div class="col-6  mt-2">
					<!-- <button class="btn btn-success w-100" @click="showUploadSPKPenawaranModal = true">Estimasi Selesai</button> -->
					<button class="btn w-100" :class="{'btn-danger' : showHide , 'btn-warning' : !showHide}" @click="showHide = !showHide">
						{{showHide ? 'Lihat Estimasi Yang Dibatalkan' : 'Tutup Estimasi Yang Dibatalkan'}}
					</button>
				</div>
				<!-- <div class="offset-md-5 col-md-2 col-6  mt-2">
					<button class="btn btn-success w-100" @click="saveChanges">
						Save Changes
					</button>
				</div> -->
				<div
					class="col-6 w-100 mt-2 "
					
				>
					<!-- <button
						class="btn btn-primary w-100"
						@click="addNewSparePart()"
						:disabled="
							!estimationData.details.insurance_id || !woDetail.price
						"
					>
						Tambah Sparepart
					</button> -->
					<button
						class="btn btn-primary w-100"
						@click="addNewSparePart()"
					>
						Tambah Sparepart
					</button>
				</div>
			</div>
			<!-- <h4 class="mt-2 col-12">Tabel Estimasi</h4> -->

			<div class="mt-2 mb-4">
				<div>
					<h5>Cari</h5>
					<input type="text" class="form-control w-100" v-model="search"/>
				</div>
			</div>
			<div style="overflow:scroll;height:550px;" >
				<!-- <table class="table text-center mt-2" v-if="!mobile">
					<thead>
						<th>No.</th>
						<th>J / P</th>
						<th>Tipe Jasa</th>
						<th>Nama Jasa / Part</th>

						<th>Deskripsi</th>
						<th>Harga / Item</th>

						<th>Jumlah</th>
						<th>Harga</th>
						<th>Status Estimasi</th>
						<th colspan="2"><i class="fa fa-cog"></i></th>
					</thead>
					
				</table> -->
				<template v-if="!mobile">
					<individualRowEstimation 
						
						v-for="estimationPart in showEstimations"
						:key="estimationPart.id"
						:class="{
							'text-red':
								estimationPart.sparepart_type == 'P' &&
								!estimationPart.is_arrived,
							'bg-date':
								curr_date !=
								moment(estimationPart.created_at).format(
									'Y-MM-DD'
								),
							'bg-lg-yellow': estimationPart.without_ppn,
							'bg-red-opac':
								estimationPart.sparepart_type == 'P' &&
								supplierPriceList &&
								supplierPriceList[estimationPart.id] && 
								supplierPriceList[estimationPart.id]
									.supplier_prices.length < 2,
							'bg-lg-blue' : 
								typeof estimationPart.is_approved_by_insurance == 'number'
								&& estimationPart.is_approved_by_insurance != 1,
							'bg-white' : true
						}"

						:estimationPart="estimationPart"
						:showSupplyApply="showSupplyApply"
						:supplierPriceList="supplierPriceList"
						@selectSPK="selectSPK"
						@deleteEstimations="deleteEstimations"
						@showPriceModal="showPriceModal"
						@updatePriceEstimation="updatePriceEstimation"
						@loadEstimation="loadEstimation"
						@addImage="addImage"
					/>
				</template>

				<div v-else>
					<div
						class="row pb-3"
						style="border-bottom:1px solid black;"
						v-for="(estimationPart,
						index) in estimationData.estimations"
						:key="estimationPart.id"
						:class="{
							cancelled: estimationPart.deleted_at != null,
							'bg-date':
								curr_date !=
								moment(estimationPart.created_at).format(
									'Y-MM-DD'
								),
							'bg-lg-yellow': estimationPart.without_ppn,
							'bg-red-opac':
								estimationPart.sparepart_type == 'P' &&
								supplierPriceList &&
								supplierPriceList[estimationPart.id] && 
								supplierPriceList[estimationPart.id]
									.supplier_prices.length < 2,
						}"
					>
						<div class="col-12 text-right mt-1">
							<b>{{
								moment(estimationPart.created_at).format(
									"DD MMM Y HH:mm"
								)
							}}</b>
						</div>
						<div class="col-6 mt-2">
							<h6>Nama</h6>
							<span>{{ estimationPart.sparepart_name }} </span>
						</div>
						<div class="col-6 mt-2">
							<h6>Deskripsi</h6>
							<span>{{ estimationPart.part_number }} </span>
						</div>
						<div class="col-12 mt-2">
							<b>Tipe Estimasi</b> :
							{{ estimationPart.sparepart_type }}
						</div>
						<div class="col-12 mt-1">
							<b>Tipe Pengerjaan</b> :
							{{
								estimationPart.type ? estimationPart.type : "-"
							}}
						</div>
						<div class="col-12 mt-1">
							<b>Jumlah Barang</b> :
							{{
								estimationPart.amount
									? parseInt(estimationPart.amount)
									: "-"
							}}
						</div>
						<div class="col-12 mt-1">
							<b>Harga Satuan</b> : Rp
							{{
								estimationPart.supplier_price_id
									? numberWithCommas(
											parseFloat(
												estimationPart.price_per_item
											)
									  )
									: "-"
							}}
						</div>
						<div class="col-12 mt-1">
							<b>Total Harga</b> : Rp
							{{
								estimationPart.price_per_item > 0
									? numberWithCommas(
											estimationPart.amount *
												(parseInt(
													estimationPart.price_per_item
												) + parseFloat(estimationPart.markup))
									  )
									: "-"
							}}
						</div>
						<div
							class="col-12 text-left mt-1"
							v-if="estimationPart.sparepart_type == 'P'"
						>
							<b
								>Status PO :
								{{
									estimationPart.is_used
										? `Barang Sudah Terpakai`
										: estimationPart.is_arrived
										? `${moment(estimationPart.time).format(
												"MMM DD, Y HH:mm"
										  )}`
										: estimationPart.is_po
										? `Barang Sudah Di Pesan`
										: `Barang Belum Dipesan`
								}}</b
							>
						</div>

						<div
							class="col-12 mt-2"
							v-if="
								estimationPart.supplier_price_id &&
									estimationPart.sparepart_type != 'J' &&
									!estimationPart.is_approved_by_insurance
							"
						>
							<button
								type="button "
								class="w-100 btn btn-warning"
								@click="estimationPart.supplier_price_id = null"
							>
								Batal Harga
							</button>
						</div>
						<div
							class="col-12 mt-2"
							v-else-if="
								estimationPart.sparepart_type == 'P' &&
									supplierPriceList &&
									supplierPriceList[estimationPart.id] &&
									supplierPriceList[estimationPart.id]
										.supplier_prices.length > 1 &&
									!estimationPart.is_supplied_by_insurance
							"
						>
							<button
								type="button "
								class="btn btn-info mb-1 w-100"
								@click="
									showPriceModal(
										estimationPart.sparepart_type,
										supplierPriceList[estimationPart.id],
										index,
										estimationPart.id
									)
								"
							>
								Pilih Harga
							</button>
						</div>
						<div
							class="col-12 mt-2"
							v-else-if="
								estimationPart.sparepart_type == 'P' &&
									supplierPriceList &&
									supplierPriceList[estimationPart.id] &&
									supplierPriceList[estimationPart.id]
										.supplier_prices.length <= 1 &&
									!estimationPart.is_supplied_by_insurance
							"
						>
							<button
								type="button"
								class="btn btn-primary mb-1  w-100"
								@click="
									$router.push({
										name: 'EstimatorSparepartDetail',
										params: { id: form_code },
									})
								"
								:disabled="estimationPart.deleted_at != null"
							>
								Ke Parts Quotation
							</button>
						</div>

						<div
							class="col-12 mt-2"
							v-if="
								estimationPart.is_approved_by_insurance ==
									null && showNegoInput[index] == false
							"
						>
							<div class="row">
								<div
									class="col-6 mt-2"
									:class="{
										'col-md-6':
											estimationPart.sparepart_type !=
											'J',
									}"
								>
									<button
										class="btn btn-outline-success mr-1 w-100"
										@click="
											selectSPK(
												'Approved',
												index,
												estimationPart.id
											)
										"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Menyetujui
									</button>
								</div>
								<div
									class="col-6 mt-2 col-md-6"
									v-if="estimationPart.sparepart_type != 'J'"
								>
									<button
										class="btn btn-outline-primary mr-1 w-100"
										@click="
											selectSPK(
												'Supplied',
												index,
												estimationPart.id
											)
										"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Disediakan
									</button>
								</div>
								<div class="col-6 mt-2">
									<button
										class="btn btn-outline-warning mr-1 w-100"
										@click="showNego(index, true)"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Nego
									</button>
								</div>
								<div
									class="mt-2"
									style="padding-left:10px;padding-right:10px"
									:class="{
										'col-6':
											estimationPart.sparepart_type !=
											'J',
										'col-12':
											estimationPart.sparepart_type ==
											'J',
									}"
								>
									<button
										class="btn btn-outline-danger  w-100"
										@click="
											selectSPK(
												'Reject',
												index,
												estimationPart.id
											)
										"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Ditolak
									</button>
								</div>
							</div>
						</div>
						<div
							class="col-12 mt-2"
							v-else-if="showNegoInput[index] == true"
						>
							<div class="row w-100">
								<!-- <div class="col-2">
									<button class="btn btn-outline-warning mr-1" disabled>Nego</button>
								</div> -->
								<div class="col-6">
									<label>Price Per Item</label>
									<input
										class="form-control"
										placeholder="Input Price Here"
										type="number"
										v-model="itemPrice"
									/>
								</div>
								<div class="col-6">
									<label>Markup Price</label>
									<input
										class="form-control"
										placeholder="Input Price Here"
										type="number"
										v-model="markupPrice"
									/>
								</div>
							</div>
							<br />
							<div class="row row-space">
								<div class="form-check form-check-inline col-5">
									<input
										:disabled="withoutPPN"
										class="form-check-input"
										style="width:20%"
										type="checkbox"
										id="inlineCheckbox1"
										value="option1"
										v-model="ppnNego"
									/>
									<label
										class="form-check-label"
										for="inlineCheckbox1"
										>Termasuk PPN</label
									>
									<!-- <br> -->
									<input
										class="form-check-input ml-1"
										style="width:20%"
										type="checkbox"
										id="inlineCheckbox1"
										value="option1"
										v-model="withoutPPN"
									/>
									<label
										class="form-check-label"
										for="inlineCheckbox1"
										>Tanpa PPN</label
									>
								</div>
								<div class="col-3">
									<button
										class="btn btn-outline-primary w-100"
										@click="
											updatePriceEstimation(
												'Nego',
												index,
												itemPrice,
												estimationPart.id
											)
										"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Nego
									</button>
								</div>
								<div class="col-3">
									<button
										class="btn btn-outline-danger w-100"
										@click="showNego(index, false)"
										:disabled="
											estimationPart.deleted_at != null
										"
									>
										Batal
									</button>
								</div>
							</div>
						</div>
						<div v-else class="col-12 mt-2">
							<div class="row">
								<div class="col-md-6 col-12 mt-auto mb-auto">
									<span><b>Status Estimasi : </b></span>
									<span
										style="color:blue"
										v-if="
											estimationPart.is_supplied_by_insurance ==
												1
										"
										>Disediakan Oleh Asuransi</span
									>
									<span
										style="color:green"
										v-else-if="
											estimationPart.is_approved_by_insurance ==
												1
										"
										>Disetujui</span
									>
									<span style="color:red" v-else
										>Ditolak</span
									>
								</div>
								<div class="col-md-6 col-12 mt-1">
									<button
										class="btn btn-outline-warning mr-1 w-100"
										@click="showNego(index, true)"
									>
										Nego
									</button>
								</div>
							</div>
							<!-- <button class=" ml-2 btn btn-outline-danger" type="button" @click="updateStatusEstimation('Cancel' , index, estimationPart.id)">Batal</button> -->
						</div>

						<div class="col-12 mt-2">
							<button
								class="btn btn-danger w-100"
								@click="deleteEstimations(estimationPart.id)"
								v-if="
									!statusText.find(
										(x) =>
											x.name == 'Penawaran' &&
											x.value != '-'
									)
								"
							>
								Hapus Estimasi
							</button>
						</div>
					</div>
				</div>

				
			</div>
		</div>
		<NewSparePartModal
			v-if="newSparepart"
			@closeModal="newSparepart = false"
			@updateTable="loadEstimation"
			:insurancePriceList="insurancePriceList"
			:data="newEstimationData"
			:brand_id="woDetail.car_id"
			:form="form"
		></NewSparePartModal>
		<!-- <hr v-if="!mobile" /> -->
		<!-- Pricing Details -->
		

		<b-card no-body @click="showPricingDetail = !showPricingDetail" class="mt-3">
			<div class=" pt-2 text-center mt-2 mb-2 row ml-3 mr-3">
				<div class="col-6 text-left">
					<h4>Liat Perincian Harga</h4>
				</div>
				<div class="col-6 text-right">
					<h4>
						<i class="fa fa-angle-double-down" v-if="!showPricingDetail"></i>
						<i class="fa fa-angle-double-up" v-else></i>
					</h4>
				</div>
				<!-- <button
					class="btn btn-outline-secondary"
					:class="{'w-25' : !this.isMobile() , 'w-100' : this.isMobile()}"
					@click="showPricingDetail = 1"
				>
					Tampilkan Detail Harga
				</button> -->
			</div>
		</b-card>
		<b-card no-body>
			<div
				class="row w-100 mt-4 ml-3 mr-3"
				v-if="estimationData && showPricingDetail"
				style="font-size:14px;"
				:class="{ cancelled: woFull && woFull.deleted_at }"
			>
				
				<div
					class="col-12 mt-2"
				>
					<h4>Rincian Harga</h4>
					<table class="table wo-stats" v-if="!mobile">
						<tr>
							<td>Total Jasa</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalJasa
									)
								}}
							</td>
							<td>Total Part</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalPart
									)
								}}
							</td>
						</tr>
						<tr>
							<td>Total Special Bahan</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalSpecialBahan
									)
								}}
							</td>
						</tr>
						<tr>
							<td>Diskon Jasa</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount
									)
								}}
							</td>
							<td>Diskon Part</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount_part
									)
								}}
							</td>
						</tr>
						<tr>
							<td>Total Discount</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.discount
										) +
											parseFloat(
												this.estimationData.details
													.discount_part
											)
									)
								}}
							</td>
							<td>PPN
								<i class="fa fa-info-circle" id="averageTime"></i>
								<b-popover target="averageTime" title="Perincian Harga PPN" triggers="hover focus" placement="bottom" >
									<!-- <span v-html="singleRow.content"></span> -->

									<table class="table table-bordered text-center">
										<thead class="thead-dark">
											<th>Nama J / P</th>
											<th>Harga PPN</th>
										</thead>
										<tbody v-for="estimation in estimationData.estimations">
											<tr>
												<td>{{estimation.alias}} - {{estimation.part_number}}</td>
												<td>{{
													estimation.without_ppn ? 
													'Harga Sudah Termasuk PPN' : 
													'Rp. ' + numberWithCommas(
														((estimation.individual_ppn ? estimation.individual_ppn : 0) * (parseFloat(estimation.amount)))
													)
												}}</td>
											</tr>
										</tbody>
									</table>
								</b-popover>

							</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(this.estimationData.details.ppn)
									)
								}}
							</td>
							
						</tr>
						<tr style="font-weight:bold;border-bottom:1px solid black">
							<td colspan="3">Bruto Net Total</td>
							<td colspan="2"></td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.totalJasa
										) +
										parseFloat(
											this.estimationData.details.totalPart
										) -
										parseFloat(
											this.estimationData.details.discount
										) -
											parseFloat(
												this.estimationData.details
													.discount_part
											)
										+ parseFloat(this.estimationData.details.ppn)
											
									)
								}}
							</td>
							<!-- <td>Total Discount Part</td>
							<td>:</td>
							<td>Rp {{numberWithCommas(this.estimationData.details.totalPart * ( this.estimationData.details.discount / 100))}} ({{this.estimationData.details.discount}}%)</td> -->
						</tr>
						<tr>
							<td>Biaya Lain Lainnya</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.otherCost
									)
								}}
							</td>
							<td>Derek</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.derek
										)
									)
								}}
							</td>
						</tr>
						<!-- <tr>
							<td colspan="3"></td>
							<td>Deskripsi Derek</td>
							<td>:</td>
							<td>{{estimationData.details.derek_desc}}</td>
						</tr> -->
						<tr>
							
							<td>PPh 23</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(this.estimationData.details.pph)
									)
								}}
								({{ 100 - pphPercentage }}%)
							</td>
						</tr>
						<tr>
							<td>Own Risk</td>
							<td>:</td>
							<td v-if="this.estimationData">
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.own_risk
										)
									)
								}}
							</td>
							<template v-if="dp">
								<td>Down Payment</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
										
											dp
											
										)
									}}
								</td>
							</template>
							
						</tr>
						<!-- <tr style="font-weight:bold;border-bottom:1px solid black">
							<td colspan="3">Net Total</td>
							<td colspan="2"></td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details
												.totalAfterDisc
										)
									)
								}}
							</td>
						</tr> -->
						
					</table>

					<div v-else class="row border border-secondary rounded p-10">
						<div class="col-12 col-md-6 mt-1">
							<h5>Total Jasa</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalJasa
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Total Part</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalPart
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Diskon Jasa</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Diskon Part</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount_part
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Total Discount</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.discount
										) +
											parseFloat(
												this.estimationData.details
													.discount_part
											)
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Biaya Lain Lainnya</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.otherCost
										)
									)
								}}
							</p>
						</div>
						<div class="col-12"><hr /></div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Own Risk</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.own_risk
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Derek</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.derek
									)
								}}
							</p>
						</div>
						<div class="col-12"><hr /></div>
						<div class="col-12 mt-1">
							<h5>Total Setelah Diskon</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details
												.totalAfterDisc -
												this.estimationData.details.ppn
										)
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>PPN</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.ppn
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>PPh 23</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(this.estimationData.details.pph)
									)
								}}
								({{ 100 - pphPercentage }}%)
							</p>
						</div>
					</div>
					
				</div>
				
			</div>
		</b-card>

		<b-card no-body class="mt-3">
			<div class=" pt-2 text-center mt-2 mb-2 row ml-3 mr-3">
				<div class="col-6 text-left">
					<h4>Net Total</h4>
				</div>
				<div class="col-6 text-right">
					<h4>Rp {{ calculateTotal(1) }}.00</h4>
				</div>
				<!-- <button
					class="btn btn-outline-secondary"
					:class="{'w-25' : !this.isMobile() , 'w-100' : this.isMobile()}"
					@click="showPricingDetail = 1"
				>
					Tampilkan Detail Harga
				</button> -->
			</div>
		</b-card>

		<!-- Estimator Options -->
		<div class="row mt-4 mb-5 pl-2" :class="{ cancelled: woFull && woFull.deleted_at }">
			<div class="col-12 mb-2">
				<h4>Opsi Aplikasi Estimator</h4>
			</div>
			<div class="col-4 col-md" v-if="estimationData">
				<button
					class="btn  w-100 mt-1"
					:class="{
						'btn-primary': !estimationData.details.no_spk,
						'btn-success': estimationData.details.no_spk,
					}"
					@click="uploadSPKModal = true"
				>
					SPK Asuransi
				</button>
			</div>
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="$set(modal , 'showDerek' , true)"
				>
					Atur Derek
				</button>
			</div>
			<!-- <div class="col-3 col-md">
				<button class="btn btn-secondary w-100 mt-1" @click="showInsertModal('Own Risk' , 'own_risk')">Atur Own Risk</button>
			</div> -->
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="showInsertModal('Discount', 'discount')"
				>
					Atur Diskon
				</button>
			</div>
			<!-- <div class="col-3 col-md">
				<button class="btn btn-secondary w-100 mt-1" @click="showSuratPuas()">Surat Puas</button>
			</div> -->
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="showNegoHistory = true"
				>
					Riwayat Nego
				</button>
			</div>
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="printEpoxy = true"
				>
					Print Epoxy
				</button>
			</div>
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="print = true"
				>
					Print Estimasi
				</button>
			</div>
			<div class="col-4 col-md">
				<button
					class="btn btn-primary w-100 mt-1"
					@click="showModalPO"
				>
					Print PO
				</button>
			</div>
		</div>

		<DerekOwnRiskDiscountModal
			v-if="insertModal"
			@closeModal="insertModal = false"
			@updateTable="getWoDetails"
			:data="Object.assign({}, estimationData.details)"
			:type="insertModalType"
			:variable="insertModalVar"
			:form_code="form_code"
		></DerekOwnRiskDiscountModal>


		<Derek 
			v-if="modal.showDerek"
			@closeModal="modal.showDerek = false"
			@updateTable="getWoDetails"
			:data="Object.assign({}, estimationData.details)"
			:type="insertModalType"
			:variable="insertModalVar"
			:form_code="form_code"
		/>

		<PrintEstimasi
			v-if="print"
			@closeModal="print = false"
			:data="estimationData"
			:form_code="form_code"
			:woDetail="woDetail"
			:total="calculateTotal(0)"
			:discount="estimationData.details.discount"
			:insuranceDetails="insuranceDetails"
			:discount_part="estimationData.details.discount_part"
			:dp="dp"
		/>

		<SuratPuasModal
			v-if="suratPuasModal"
			@closeModal="suratPuasModal = false"
			:form_code="form_code"
		/>

		<NegoHistory
			v-if="showNegoHistory"
			@closeModal="showNegoHistory = false"
			:data="estimationData"
		/>

		<uploadSPK
			v-if="uploadSPKModal"
			@closeModal="uploadSPKModal = false"
			@updateTable="getWoDetails"
			:data="estimationData"
			:spk_documents="woDetail.spk_documents"
			:form_code="form_code"
		/>

		<selectSupplierModal
			v-if="supplierSparepartPriceList"
			:showData="supplierSparepartPriceList"
			@submit="updatePriceEstimation"
			@closeModal="supplierSparepartPriceList = null;"
			@updateEstimation="loadEstimation"
		/>

		<addInsurance
			v-if="showAddModal"
			:car="woDetail.car"
			:customer="woDetail.customer"
			@closeModal="showAddModal = false"
			@updateTable="getWoDetails"
		/>

		<selectSPK
			v-if="showSelectSPKModal"
			:spk_documents="woDetail.spk_documents"
			:data="estimationData"
			:dataSelect="selectSPKData"
			:status="selectedStatus"
			@closeModal="showSelectSPKModal = false"
			@updateTable="getWoDetails"
			@updateStatusEstimation="updateStatusEstimation"
		/>

		<uploadSPKPenawaran
			v-if="showUploadSPKPenawaranModal"
			:form_code="form_code"
			@closeModal="showUploadSPKPenawaranModal = false"
			@spkPenawaranDone="spkPenawaranDone"
		/>

		<setPriceModal
			v-if="modal.setPrice"
			@closeModal="modal.setPrice = false"
			:chassis_number="woDetail.nomor_rangka"
			@updateTable="
				modal.setPrice = false;
				getWoDetails();
			"
		/>
		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="
				`Change Policy Insurance For Work Order Number ${form_code}__${woDetail.nomor_polisi} - ${woDetail.tipe} - ${woDetail.customer.name}`
			"
			@approved="allowChangePolicy"
			@token="changePolicy"
		/>

		<PrintPO
			v-if="modal.printPoModal == true"
			@closeModal="modal.printPoModal = false"
			:data="
				estimationData.estimations.filter(
					(x) => x.sparepart_type == 'P'
				)
			"
			:dataSupplierPriceList="supplierPriceList"
			:workOrderDetail="woDetail"
			:form_code="form_code"
			@loadEstimation="loadEstimation"
		/>

		<preview-image
			v-if="modal.preview"
			@closeModal="modal.preview = false"
			:image="modal.previewData"
		></preview-image>

		<upload-image
			v-if="modal.upload"
			endpoint="/api/v1/workorder/steps/upload"
			:title="'Tambah Gambar Sparepart Rusak'"
			:image_count="5"
			@closeModal="modal.upload = false"
			@onResponse="finaliseImage"
		></upload-image>

		<printEpoxy 
			v-if="printEpoxy"
			@closeModal="printEpoxy = false"
			:work_order_code="form_code"
		/>

		<addTPLInsurance
			v-if="modal.showTPL"
			@closeModal="modal.showTPL = false"
			@done="
				modal.showTPL = false;
				getWoDetails();
			"
			:form_destination="woDetail.work_order_id"
		/>
	</div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import env from "@/env";

import NewSparePartModal from "./children/NewSparepart";
import DerekOwnRiskDiscountModal from "./children/DerekOwnRiskDiscountModal";
import PrintEstimasi from "./children/PrintEstimasi";
import NegoHistory from "./children/NegoHistory";
import uploadSPK from "./children/uploadSPK";
import selectSPK from "./children/selectSPK";
import selectSupplierModal from "./children/selectSupplierModal";
import SuratPuasModal from "./children/SuratPuasModal";
import addInsurance from "./children/addInsurance";
import uploadSPKPenawaran from "./children/uploadSPKPenawaran";
import setPriceModal from "./children/setPriceModal";
import adminAuth from "@/components/modal/adminAuthorization";
import PrintPO from "./children/PrintPO";
import UploadImage from "@/components/modal/uploadImage.vue";
import PreviewImage from "@/components/modal/previewImage.vue";
import individualRowEstimation from './children/individualRowEstimation.vue'
import Derek from './children/Derek.vue'
import printEpoxy from './children/printEpoxy.vue'
import AddTPLInsurance from './children/addTPLInsurance.vue';

export default {
	components: {
		adminAuth,
		Multiselect,
		NewSparePartModal,
		DerekOwnRiskDiscountModal,
		PrintEstimasi,
		NegoHistory,
		uploadSPK,
		selectSPK,
		selectSupplierModal,
		SuratPuasModal,
		addInsurance,
		uploadSPKPenawaran,
		setPriceModal,
		PrintPO,
		UploadImage,
		PreviewImage,
		individualRowEstimation,
		Derek,
		printEpoxy,
		AddTPLInsurance
	},
	data() {
		return {
			env,
			mobile: this.isMobile(),
			dp : 0,
			otherCost : 0,
			curr_date: null,
			ppnNego: false,
			withoutPPN: false,
			moment: moment,
			form_code: this.$route.params.id,
			showPricingDetail: 0,
			woDetail: null,
			woFull : null,
			mobile: this.isMobile(),
			search : '',
			statusText: [
				{ name: "Janji Keluar" },
				{ name: "Status SPK" },
				// {name : 'Penawaran'},
				{ name: "Selesai" },
				{ name: "Keluar Mobil" },
				{ name: "Penagihan" },
				{ name: "Kirim Kwitansi" },
				{ name: "Pembayaran" },
			],
			estimationData: null,
			totalSparepartPurchasePrice: 0,
			model: {
				sparePart: {
					amount: 0,
					estimation_work_order_id: 0,
					sparepart_id: null,
					sparepart_size: null,
					attachment_id: null,
					insurance_car_type_id: null,
					insurance_company_id: null,
					without_ppn: false,
					type: null,
					extension : ''
				},
			},
			form: {
				insurance_company_id: null,
				sparepart_id: null,
				insurance_car_type_id: null,
				price: null,
			},
			newEstimationData: null,
			newSparepart: 0,
			insertModal: false,
			insertModalType: "",
			insertModalVar: "",
			print: false,
			printEpoxy : false,
			insuranceDetails: null,
			supplierPriceList: null,
			supplierSparepartPriceList: null,
			showNegoInput: [],
			itemPrice: 0,
			reloadTable: false,
			showNegoHistory: false,
			uploadSPKModal: false,
			suratPuasModal: false,
			listInsuraceCarTypes: null,
			priceCondition: "",
			priceConditionText: "",
			priceListCategoryID: null,
			insurancePriceList: null,
			showAddModal: false,
			pphPercentage: null,
			showUploadSPKPenawaranModal: false,
			markupPrice: 0,
			showSelectSPKModal: false,
			selectSPKData: null,
			reason: "",
			recentLog: null,
			showStatistics: false,
			showSupplyApply : false,
			modal: {
				upload: false,
				uploadRef: null,
				preview: false,
				previewData: null,
				setPrice: false,
				showAdminAuth: false,
				printPoModal: false,
				showDerek : false,
				showTPL : false
			},
			showHide : true,
			pending_estimation : [],
			selectedStatus : '',
			totalJasa : 0,
			totalPart : 0,
			totalSpecialBahan : 0
		};
	},
	computed : {
		showEstimations () {
			let estimationList = this.estimationData.estimations

			if(this.showHide) {
				estimationList = estimationList.filter(x => !x.deleted_at)
			}

			if(this.search == '')
				return estimationList
			else {
				let newList = []
				for(var i = 0 ; i < estimationList.length ; i++) {
					let curEstimation = estimationList[i]

					// console.log(curEstimation.part_number , curEstimation.sparepart_name , this.search)

					if(curEstimation.part_number)
						curEstimation.part_number.toLowerCase().includes(this.search.toLowerCase()) || curEstimation.sparepart_name.toLowerCase().includes(this.search.toLowerCase()) ? newList.push(curEstimation) : ''
					else 
						curEstimation.sparepart_name.toLowerCase().includes(this.search.toLowerCase()) ? newList.push(curEstimation) : ''

					// console.log(newList)
				}
				return newList
			}
		}
	},
	async mounted() {
		this.getWoDetails();
		this.getWoOtherCost()
		this.loadPaymentList()
		

		//Show Statistics Work Order

		this.$http
			.get("/api/v1/check")
			.then((resp) => {
				let data = resp.data.data;
				let super_user = data.is_superuser;

				if (super_user) {
					this.showStatistics = true;
					this.showSupplyApply = true;
				}
			})
			.catch((err) => {
				console.log(err);
			});
	},
	methods: {
		bahanUsageList () {
			this.$router.push({
				name : 'InventoryUsage',
				query : {
					form_code : this.woDetail.work_order_id
				}
			})
		},
		showTPLModal () {
			if(!this.insuranceDetails) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Isi Asuransi Untuk Work Order Tersebut Dahulu.'])
				return
			}

			this.modal.showTPL = true;
		},
		goToPembayaran () {
			this.$router.push({ name : 'FinanceWorkOrderPayment', query : { form_code : this.woDetail.work_order_id , from : 'EstimatorApplication' } })
		},
		async mergePending (data) {
			try {
				let response = await this.$http.patch('/api/v1/estimations/merge-estimation/' + this.woDetail.work_order_id , data)
				this.$store.dispatch('triggerAlert' , [true , 'Merge Complete'])
				this.getWoDetails()
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong.' , err])
				console.log(err)
			}
		},
		saveChanges() {
			for (var i = 0; i < this.estimationData.estimations.length; i++) {
				let curEstimation = this.estimationData.estimations[i];
				let index = i;
				console.log(curEstimation)

				this.$http
					.patch("/api/v1/estimations/" + curEstimation.id, {
						type: curEstimation.type,
						part_number : curEstimation.part_number
					})
					.then((resp) => {
						if (
							index ==
							this.estimationData.estimations.length - 1
						) {
							this.loadEstimation();
							this.$store.dispatch("triggerAlert", [
								true,
								"Changes have been saved.",
							]);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			}
		},
		finaliseImage(imageData) {
			this.modal.upload = false;
			let data = Array.isArray(imageData) ? imageData : [imageData];

			let estimationId = this.modal.uploadRef.id;
			let obj = {
				damaged_image: data.join(','),
			};

			this.$http
				.patch("/api/v1/estimations/" + estimationId, obj)
				.then((resp) => {
					this.$store.dispatch("triggerAlert", [
						true,
						[`Tambah Gambar Rusak Berhasil`],
					]);
					this.loadEstimation();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		addImage(estimationPart) {
			this.modal.uploadRef = estimationPart;
			this.modal.upload = true;
		},
		previewImage(image) {
			this.modal.previewData = image.split(",");

			this.modal.previewData = this.modal.previewData.map(
				(x) => env.baseImage + "/" + x
			);
			this.modal.preview = true;
		},
		changeWorkOrder(type) {
			let url = `/api/v1/workorder/sequence?type=${type}&workOrder=${this.woDetail.work_order_id}`;
			this.$http
				.get(url)
				.then((resp) => {
					let data = resp.data.data;
					this.$router.push({
						name: "EstimatorApplication",
						params: { id: data.form_code },
					})

					// this.$router.replace({
					// 	name: "EstimatorApplication",
					// 	params: { id: data.form_code },
					// });
					this.form_code = data.form_code;
					this.getWoDetails();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showModalPO() {
			// this.modal.printPoModal = true;
			this.$set(this.modal , 'printPoModal' , true)
			// console.log(this.modal.printPoModal)
		},
		allowChangePolicy(token, prevToken) {
			this.modal.showAdminAuth = false;

			if (token) {
				this.$http.defaults.headers.common["Authorization"] = prevToken;
			}
			this.$store.dispatch("triggerAlert", [
				true,
				"Admin Permission Success",
			]);

			this.estimationData.details.insurance_id = null;
			this.insuranceDetails = null;
		},
		changePolicy(token = null) {
			let prevToken = "";

			if (token) {
				prevToken = this.$http.defaults.headers.common["Authorization"];

				this.$http.defaults.headers.common["Authorization"] =
					"Bearer " + token;
			}

			this.$http
				.get("/api/v1/check")
				.then((resp) => {
					let data = resp.data.data;
					let super_user = data.is_superuser;

					if (super_user) {
						this.allowChangePolicy(token, prevToken);
					} else {
						this.modal.showAdminAuth = true;
						this.reason = token
							? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
							: "Untuk Memakai Fitur Ganti Polis, Diperlukan Otorisasi Administrator.";
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		openDocument(url) {
			if(!url) {
				this.$store.dispatch('triggerAlert' , [false , 'Document Tidak Tersedia.'])
				return
			}
			window.open(`${env.baseImage}/${url}`, "_blank");
		},
		spkPenawaranDone() {
			this.showUploadSPKPenawaranModal = false;
			this.estimationDone();
		},
		estimationDone() {
			let data = {
				logType: 3,
			};

			this.$http
				.post("/api/v1/workorder/log/" + this.form_code, data)
				.then((resp) => {
					this.$store.dispatch("triggerAlert", [
						true,
						"Penawaran Work Order Selesai.",
					]);
					this.getWoDetails();
				})
				.catch((err) => {
					this.$store.dispatch("triggerAlert", [
						false,
						"Ada Terjadi Kendala. Mohon dicoba beberapa saat lagi.",
					]);
				});
		},
		newAsuransi(companyType) {
			this.$http
				.get("/api/v1/insurance/company?pagination=false")
				.then((resp) => {
					let data = resp.data.data;
					let umumId = data.find((x) => x.name == companyType).id;

					let form = {
						policy_type: 1,
						policy_expiry: "3000-12-31",
						insured_name: this.woDetail.customer.name,
						policy_number: Date.now().toString(),
						insurance_company: umumId,
						customer_id: this.woDetail.customer.id,
						car_id: this.woDetail.car.car_id,
						car_color_id: this.woDetail.car.car_color_id,
						year: this.woDetail.car.year,
					};

					this.$http
						.put(
							`/api/v1/masterData/customer_car/${this.woDetail.car.chassis_number}`,
							form
						)
						.then((resp) => {
							// alert(`Partshop ${vm.form.name} has been created`);
							this.$store.dispatch("triggerAlert", [
								true,
								[
									`Polis Nomor ${form.policy_number} telah berhasil dibuat`,
								],
							]);
							this.getWoDetails();
						})
						.catch((err) => {
							console.log(err);
							this.$store.dispatch("triggerAlert", [
								false,
								String(err)
									.split("Error:")[1]
									.split("; "),
							]);
						});
				})
				.catch((err) => {
					console.log(err);
				});
		},
		insuranceCarList() {
			this.$http
				.get("/api/v1/insurance/car")
				.then((resp) => {
					this.listInsuraceCarTypes = resp.data.data;
					let price = this.woDetail.price;
					// console.log(price)
					for (var i = 0; i < this.listInsuraceCarTypes.length; i++) {
						let type = this.listInsuraceCarTypes[i];
						let min = parseFloat(type.min ? type.min : 0);
						let max = parseFloat(
							type.max ? type.max : 999999999999999
						);

						if (price >= min && price <= max) {
							this.priceCondition = `Kategori ${type.id}`;
							this.model.sparePart.insurance_car_type_id =
								type.id;
							this.priceListCategoryID = type.id;
							this.priceConditionText =
								type.id <= 4
									? `(Rp ${this.numberWithCommas(
											min
									  )} - Rp ${this.numberWithCommas(max)})`
									: `> Rp ${this.numberWithCommas(min)}`;
							this.getInsurancePriceList(type.id);
						}
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showSuratPuas() {
			if (!this.insuranceDetails) {
				this.$store.dispatch("triggerAlert", [
					false,
					[
						`Mohon dipilih asuransi terlebih dahulu untuk memakai fitur tersebut.`,
					],
				]);
				return;
			}

			this.suratPuasModal = true;
		},
		showPriceModal(type, obj, index, id) {
			this.supplierSparepartPriceList = {
				priceList: obj,
				index: index,
				id: id,
				type: type,
			};
		},
		showNego(index, bool) {
			this.showNegoInput[index] = bool;
			console.log(this.showNegoInput[index]);
			this.itemPrice = 0;
			this.reloadTable = true;
			this.reloadTable = false;
		},
		getPPhPercentage(id) {
			this.model.sparePart.insurance_company_id = id;
			this.$http
				.get("/api/v1/insurance/company/" + id)
				.then((resp) => {
					let data = resp.data.data;
					this.pphPercentage = data.pph_insurance;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getInsurancePriceList(id) {
			this.form.insurance_car_type_id = id;
			// console.log(this.insuranceDetails);
			this.form.insurance_company_id = this.insuranceDetails ? this.insuranceDetails.insurance_company : 17;

			this.getPPhPercentage(this.form.insurance_company_id);

			this.$http
				.get(
					"/api/v1/insurance/pricelist/" +
						id +
						"?insurance_company_id=" +
						this.form.insurance_company_id +
						"&pagination=false"
				)
				.then((resp) => {
					let insurancePriceList = resp.data.data;
					this.insurancePriceList = insurancePriceList;

					for (
						var i = 0;
						i < this.estimationData.estimations.length;
						i++
					) {
						this.estimationData.estimations[
							i
						].insurancePriceList = insurancePriceList.find(
							(x) =>
								x.sparepart_id ==
								this.estimationData.estimations[i].sparepart_id
						);
						// console.log(this.estimationData.estimations[i].insurancePriceList)
					}

					this.reloadTable = true;
					this.reloadTable = false;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getSupplierPrice() {
			this.$http
				.get("/api/v1/estimations-supplier/" + this.form_code)
				.then((resp) => {
					let priceSupplier = resp.data.data;
					this.supplierPriceList = {};

					for (
						var i = 0;
						i < this.estimationData.estimations.length;
						i++
					) {
						// let estimations = this.estimationData.estimations.find(x => x.sparepart_id == priceSupplier[i].sparepart_id)
						// estimations.supplierPriceList = estimations.supplier_prices
						let supplierPriceList = priceSupplier.find(
							(x) =>
								x.estimations_id ==
								this.estimationData.estimations[i].id
						);
						this.supplierPriceList[
							this.estimationData.estimations[i].id
						] = supplierPriceList
							? supplierPriceList
							: { supplier_prices: [] };
						// console.log(this.supplierPriceList)
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		updateInsuranceEstimation(insuranceId) {
			let data = {
				insurance_id: insuranceId,
			};
			this.$http
				.patch("/api/v1/workorder-estimation/" + this.form_code, data)
				.then((resp) => {
					this.$store.dispatch("triggerAlert", [
						true,
						[`Asuransi Berhasil Ditambahkan`],
					]);
					// this.$emit('updateTable');
					// this.$emit('closeModal');
					this.getWoDetails();
					this.getInsurancePriceList();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showInsertModal(name, variable) {
			// console.log(name)
			this.insertModalType = name;
			this.insertModalVar = variable;
			this.insertModal = true;
		},
		deleteEstimations(id) {
			this.$swal
				.fire({
					title: "Apakah anda yakin?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Saya Yakin",
					cancelButtonText: "Kembali",
				})
				.then((result) => {
					if (result.value) {
						this.$http
							.delete("/api/v1/estimations/" + id)
							.then((resp) => {
								this.loadEstimation();
							})
							.catch((err) => {
								console.log(err);
							});
					}
				});
		},
		updatePrice(estimationId, id, type, price, description) {
			let estimationPart = this.estimationData.estimations.find(
				(x) => x.id == estimationId
			);
			console.log(estimationPart)
			let supplierPrice = this.supplierPriceList[
				estimationPart.id
			].supplier_prices.find(
				(x) => x.id == estimationPart.supplier_price_id
			);

			console.log(supplierPrice)
			if(!supplierPrice) {
				supplierPrice = {
					without_ppn : 0
				}
			}

			let obj = {
				supplier_price_id: parseFloat(id),
				description: description ? description : "",
			};

			if (estimationPart.is_approved_by_insurance) {
				let oldPrice = parseFloat(estimationPart.price_per_item ? estimationPart.price_per_item : 0);
				let newPrice = parseFloat(price);
				// console.log(price , newPrice)
				let tax = 0;
				if (!supplierPrice.without_ppn) {
					tax = oldPrice  * this.estimationData.ppn - newPrice * this.estimationData.ppn;
				}

				if (estimationPart.sparepart_type == "P") {
					obj.accountTransaction = [
						{
							type: "Inventory",
							amount: oldPrice - newPrice,
							debit_credit: -1,
							description: `Nego Adjustment Inventaris ${estimationPart.sparepart_name}`,
						},
						{
							type: "Account Receivable",
							amount: oldPrice - newPrice + tax,
							debit_credit: 1,
							description: `Nego Adjustment Account Receivable Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Tax Payable",
							amount: tax,
							debit_credit: -1,
							description: `Nego Adjustment PPN Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Cost Of Goods Sold",
							amount: oldPrice - newPrice,
							debit_credit: 1,
							description: `Nego Adjustment Cost Of Goods Sold Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Unearned Revenue",
							amount: oldPrice - newPrice,
							debit_credit: -1,
							description: `Nego Adjustment Unearned Revenue Untuk ${estimationPart.sparepart_name}`,
						},
					];
				} else {
					obj.accountTransaction = [
						{
							type: "Account Receivable",
							amount:
								oldPrice -
								newPrice +
								tax +
								((100 - this.pphPercentage) / 100) *
									0.02 *
									(oldPrice * (1 + this.estimationData.ppn)) -
								((100 - this.pphPercentage) / 100) *
									0.02 *
									(newPrice * (1 + this.estimationData.ppn)),
							debit_credit: 1,
							description: `Nego Adjustment Account Receivable Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Tax Payable",
							amount: tax,
							debit_credit: -1,
							description: `Nego Adjustment PPN Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Tax Payable",
							amount:
								((100 - this.pphPercentage) / 100) *
									0.02 *
									(oldPrice * (1 + this.estimationData.ppn)) -
								((100 - this.pphPercentage) / 100) *
									0.02 *
									(newPrice * (1 + this.estimationData.ppn)),
							debit_credit: -1,
							description: `Nego Adjustment PPH23 Untuk ${estimationPart.sparepart_name}`,
						},
						{
							type: "Unearned Revenue",
							amount: oldPrice - newPrice,
							debit_credit: -1,
							description: `Nego Adjustment Unearned Revenue Untuk ${estimationPart.sparepart_name}`,
						},
					];
				}
			}
			console.log(obj);

			this.$http
				.patch("/api/v1/estimations/" + estimationId, obj)
				.then((resp) => {
					// this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
					this.loadEstimation();
					this.supplierSparepartPriceList = null;
				})
				.then(() => {
					if (type == "Nego") {
						this.$http
							.post(
								"/api/v1/estimations/" +
									estimationId +
									"/negotiation",
								{ new_price: parseFloat(price) }
							)
							.then((resp) => {
								this.$store.dispatch("triggerAlert", [
									true,
									[`Nego Berhasil Disimpan`],
								]);
							})
							.catch((err) => {
								console.log(err);
							});
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		updatePriceEstimation(type, index, price, id, description) {
			// console.log(id)
			let selectedEstimation = this.estimationData.estimations.find(x => x.id == id)
			index = this.estimationData.estimations.findIndex((x) => x.id == id)

			if (
				type == "Nego" &&
				selectedEstimation.supplier_price_id == null
			) {
				this.$store.dispatch("triggerAlert", [
					false,
					["Estimasi Sparepart Belum Ada!"],
				]);
				return;
			}

			if (type == "Nego") {
				// console.log(this.estimationData.estimations[index])
				let supplier_id = this.supplierPriceList[
					selectedEstimation.id
				].supplier_prices.find(
					(x) =>
						x.id ==
						selectedEstimation.supplier_price_id
				);

				console.log('supplier_id')
				this.$http
					.post("/api/v1/estimations-supplier", {
						estimations_id: id,
						price_per_item: parseFloat(price.price),
						ppn_included: price.ppnNego,
						without_ppn: price.withoutPPN,
						markup: parseFloat(this.markupPrice),
						supplier_id: supplier_id.supplier_id,
					})
					.then((resp) => {
						let data = resp.data.data;
						this.markupPrice = 0;
						this.ppnNego = false;
						this.withoutPPN = false;
						this.updatePrice(id, data.id, type, price.price);
					})
					.catch((err) => {
						console.log(err);
						this.$store.dispatch('triggerAlert' , [false , err.response.data])
					});
			} else if (typeof price == "object" && price.markupPrice != null) {
				// console.log(price)
				this.$http
					.patch("/api/v1/estimations-supplier/" + price.id, {
						markup: price.markupPrice,
					})
					.then((resp) => {
						this.updatePrice(
							id,
							price.id,
							type,
							null,
							description ? description : null
						);
					})
					.catch((err) => {
						console.log(err);
						this.$store.dispatch("triggerAlert", [
							false,
							"Something Went Wrong. Please Try Again Later",
						]);
					});
			} else {
				this.updatePrice(id, price, type, null);
			}
		},
		selectSPK(status, index, id) {

			let selectedEstimation = this.estimationData.estimations.find(x => x.id == id)
			index = this.estimationData.estimations.findIndex((x) => x.id == id)

			this.selectedStatus = status

			if (
				(status != "Supplied" && status != 'Reject') &&
				selectedEstimation.supplier_price_id == null
			) {
				this.$store.dispatch("triggerAlert", [
					false,
					["Estimasi Sparepart Belum Ada!"],
				]);
				return;
			}

			console.log(selectedEstimation)

			if(this.insuranceDetails.insuranceCompany.id != 17) {
				
				if (status == 'Reject') {
					this.updateStatusEstimation(
						status,
						index,
						id
					);
					this.$store.dispatch("triggerAlert", [
						true,
						["Tolak Estimasi Berhasil"],
					]);
					return;

				}
				else if (!this.estimationData.details.no_spk) {
					this.$store.dispatch("triggerAlert", [
						false,
						["Mohon untuk menyediakan Surat SPK Terlebih Dahulu!"],
					]);
					return;
				}
				

				let price =
					parseFloat(
						selectedEstimation.price_per_item
					) * parseInt(selectedEstimation.amount);

				this.showSelectSPKModal = true;
				this.selectSPKData = {
					status,
					id,
					index,
					price,
				};
			}
			else {
				let price =
					parseFloat(
						selectedEstimation.price_per_item
					) * parseInt(selectedEstimation.amount);
				this.updateStatusEstimation(status , index , id , null , price)
				this.$store.dispatch('triggerAlert' , [true , 'Ubah Status Estimasi Selesai'])
			}

			
		},
		updateStatusEstimation(status, index, id, spk_id = null, price = null , options = null) {
			let estimationPart = this.estimationData.estimations[index];
			// console.log(estimationPart)

			if (status == "Approved") {
				this.estimationData.estimations[
					index
				].is_approved_by_insurance = true;
				this.estimationData.estimations[
					index
				].is_supplied_by_insurance = false;
			} else if (status == "Cancel") {
				this.estimationData.estimations[
					index
				].is_approved_by_insurance = null;
				this.estimationData.estimations[
					index
				].is_supplied_by_insurance = null;
			} else if (status == "Reject") {
				this.estimationData.estimations[
					index
				].is_approved_by_insurance = false;
				this.estimationData.estimations[
					index
				].is_supplied_by_insurance = false;
			} else if (status == "Supplied") {
				this.estimationData.estimations[
					index
				].is_approved_by_insurance = true;
				this.estimationData.estimations[
					index
				].is_supplied_by_insurance = true;

				let estimation = this.estimationData.estimations[index];

				// let data = {
				// 	estimation_id: estimation.id,
				// 	spare_part_id: estimation.sparepart_id,
				// 	insurance_company_id: this.insuranceDetails
				// 		.insurance_company,
				// };

				// this.$http
				// 	.post("/api/v1/purchase-order/" + this.form_code, data)
				// 	.then((resp) => {
				// 		// console.log(resp.data.data)
				// 		this.getEstimationDetails();
				// 	})
				// 	.catch((err) => {
				// 		console.log(err);
				// 	});
			}

			let data = Object.assign(
				{},
				{
					is_approved_by_insurance: this.estimationData.estimations[
						index
					].is_approved_by_insurance,
					is_supplied_by_insurance: this.estimationData.estimations[
						index
					].is_supplied_by_insurance,
					estimation_status_change: new moment().format(
						"Y-MM-DD HH:mm:ss"
					),
				}
			);

			spk_id ? (data.spk_id = spk_id) : "";
			price ? (data.price = price) : 0;

			if(options) {
				if(options.supplier)
					data.supplier_id = options.supplier
				data.arrival_date = parseInt(new moment(options.date).diff(new moment(), 'days' ,true))

			}
			

			if (status == "Approved") {
				let supplierPrice = this.supplierPriceList[
					estimationPart.id
				].supplier_prices.find(
					(x) => x.id == estimationPart.supplier_price_id
				);
				
				console.log(supplierPrice)
				let tax = 0;
				if (!supplierPrice.without_ppn) {
					tax = parseFloat(price * this.estimationData.ppn);
				}

				if (estimationPart.sparepart_type == "P") {
					console.log(options + 'hahaha')
					
					let markup = options ? options.markup ? options.markup : parseFloat(
						estimationPart.markup ? estimationPart.markup : 0 
					) : 0;
					

					data.accountTransaction = [
						{
							type: "Account Receivable",
							amount: price + tax + markup,
							debit_credit: -1,
							description: `${estimationPart.sparepart_name} Disetujui Oleh Asuransi`,
						},
					];
					data.accountTransaction.push({
						type: "Inventory",
						amount: price - markup,
						debit_credit: -1,
						description: `Penagihan Inventaris ${estimationPart.sparepart_name} Untuk Pengerjaan`,
					});
					data.accountTransaction.push({
						type: "Tax Payable",
						amount: tax,
						debit_credit: 1,
						description: `Hutang PPN 10 % Untuk ${estimationPart.sparepart_name}`,
					});
					data.accountTransaction.push({
						type: "Markup Inventory",
						amount: markup,
						debit_credit: 1,
						description: `Markup Harga Inventaris ${estimationPart.sparepart_name}`,
					});
					data.accountTransaction.push({
						type: "Unearned Revenue",
						amount: price - markup,
						debit_credit: 1,
						description: `Total Pendapatan Untuk ${estimationPart.sparepart_name}`,
					});
					data.accountTransaction.push({
						type: "Cost Of Goods Sold",
						amount: price - markup,
						debit_credit: -1,
						description: `Cost Of Goods Sold Untuk ${estimationPart.sparepart_name}`,
					});
				} else {
					data.accountTransaction = [
						{
							type: "Account Receivable",
							amount:
								price +
								tax +
								((100 - this.pphPercentage) / 100) *
									0.02 *
									(price * 1.1),
							debit_credit: -1,
							description: `${estimationPart.sparepart_name} Disetujui Oleh Asuransi`,
						},
					];
					data.accountTransaction.push({
						type: "Tax Payable",
						amount: tax,
						debit_credit: 1,
						description: `Pajak PPN Untuk ${estimationPart.sparepart_name}`,
					});
					data.accountTransaction.push({
						type: "Tax Payable",
						amount:
							((100 - this.pphPercentage) / 100) *
							0.02 *
							(price * 1.1),
						debit_credit: 1,
						description: `Pajak PPH23 Untuk ${estimationPart.sparepart_name}`,
					});

					data.accountTransaction.push({
						type: "Unearned Revenue",
						amount: price,
						debit_credit: 1,
						description: `Total Pendapatan Untuk ${estimationPart.sparepart_name}`,
					});
				}
				console.log(data.accountTransaction);
			}

			this.$http
				.patch("/api/v1/estimations/" + id, data)
				.then((resp) => {
					// this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
					this.loadEstimation();
					this.showSelectSPKModal = false;
				})
				.catch((err) => {
					console.log(err);
					this.$store.dispatch('triggerAlert' , [false , err.response.data.data])
				});
		},

		calculateTotal(ppn) {
			// console.log(this.estimationData.details)
			if(!this.estimationData) return "0";

			let priceAfterDiscountJasa =
				this.estimationData.details.totalJasa -
				parseFloat(this.estimationData.details.discount);
			let priceAfterDiscountPart =
				this.estimationData.details.totalPart -
				parseFloat(this.estimationData.details.discount_part);
			this.estimationData.details.totalAfterDisc =
				priceAfterDiscountJasa +
				priceAfterDiscountPart +
				parseFloat(this.estimationData.details.derek) -
				parseFloat(this.estimationData.details.own_risk) - this.otherCost
				+ parseFloat(this.estimationData.details.totalSpecialBahan);

			// console.log(priceAfterDiscountJasa + priceAfterDiscountPart - 300000 - 15000 + this.estimationData.details.ppn);
			if (ppn)
				this.estimationData.details.totalAfterDisc += this.estimationData.details.ppn;

			// alert(this.estimationData.details.totalAfterDisc)
			this.estimationData.details.pph =
				((100 - this.pphPercentage) / 100) *
				0.02 *
				priceAfterDiscountJasa;

			

			let total =
				this.estimationData.details.totalAfterDisc -
				this.estimationData.details.pph - this.dp;


			return this.numberWithCommas(total.toFixed(0));
		},
		addNewSparePart() {
			let paidData = this.statusText.find(x => x.name == 'Pembayaran')
			let paid = paidData.value && paidData.value == '-' ? false : true
			console.log(paidData , paid)
			

			if(!this.woDetail.price) {
				this.$swal({
					icon : 'info',
					title : 'Isi Harga Mobil',
					html : 'Mohon diisi harga mobil untuk tambah estimasi sparepart.'
				})
				return
			}
			else if (this.woFull.serviceType != 'Process Mobil' && !this.estimationData.details.insurance_id) {
				this.$swal({
					icon : 'info',
					title : 'Isi Asuransi Bersangkutan',
					html : 'Mohon dipilih atau dibuat polis bersangkutan dengan work order ini.'
				})
				return
			}
			else if (paid) {
				this.$swal({
					icon : 'info',
					title : 'Wo Sudah Dibayar',
					html : 'Tidak bisa nambah sparepart jika wo sudah dibayar'
				})
				return
			}
			
			this.newEstimationData = Object.assign({}, this.model.sparePart);
			this.newEstimationData.estimation_work_order_id = this.estimationData.details.id;
			// this.newSparepart = true;
			/*
				:insurancePriceList="insurancePriceList"
				:data="newEstimationData"
				:brand_id="woDetail.car_id"
				:form="form"
			*/
			this.$router.push({ 
				name : 'EstimatorAddSparepart',
				query : {
					insurancePriceList : JSON.stringify(this.insurancePriceList),
					data : this.newEstimationData,
					brand_id : this.woDetail.car_id,
					form : JSON.stringify(this.form),
					form_code : this.form_code
				}
			})
		},
		async getPurchaseOrderDetails() {
			let result = await this.$http.get(
				"/api/v1/purchase-order/" + this.form_code
			);

			return result.data.data;
		},
		loadEstimation() {
			this.$http
				.get(
					"/api/v1/workorder-estimation/" +
						this.form_code +
						"?showDeleted=true"
				)
				.then(async (resp) => {
					this.estimationData = resp.data.data;
					let ppnPercentage = this.estimationData.ppn
					// console.log(this.estimationData)
					let estimationList = this.estimationData.estimations;

					let ppnTotal = 0;
					let listOfPO = await this.getPurchaseOrderDetails();

					let temp = JSON.parse(JSON.stringify(estimationList));

					let orderedDates = temp.sort(function(a, b) {
						// Turn your strings into dates, and then subtract them
						// to get a value that is either negative, positive, or zero.
						return new Date(a.created_at) - new Date(b.created_at);
					});

					this.curr_date = orderedDates[0]
						? moment(orderedDates[0].created_at).format("Y-MM-DD")
						: moment().format("Y-MM-DD");

					this.totalSparepartPurchasePrice = 0;
					this.estimationData.details.totalJasa += this.estimationData.details.notApprovedJasa
					this.estimationData.details.totalPart += this.estimationData.details.notApprovedPart
					this.estimationData.details.totalSpecialBahan += this.estimationData.details.notApprovedSpecialBahan

					this.totalJasa = this.estimationData.details.totalJasa
					this.totalPart = this.estimationData.details.totalPart
					this.totalSpecialBahan = this.estimationData.details.totalSpecialBahan

					let derekList = this.estimationData.details.derekData.map(x => parseFloat(x.amount))
					
					const reducer = (accumulator, curr) => accumulator + curr;

					this.estimationData.details.derek = derekList.length > 0 ? derekList.reduce(reducer) : 0

					let discountMultJasa = parseFloat(this.estimationData.details.discount) / this.totalJasa
					let discountMultPart = parseFloat(this.estimationData.details.discount_part) / this.totalPart
					

					let discountPPN = parseFloat(this.estimationData.details.discount) + parseFloat(this.estimationData.details.discount_part)
					

					for (var i = 0; i < estimationList.length; i++) {
						let discountMult = estimationList[i].sparepart_type == 'J' ? discountMultJasa : discountMultPart
						let deductible = (parseFloat(estimationList[i].price_per_item) * parseFloat(estimationList[i].amount) * discountMult)
						this.showNegoInput[i] = false;

						if (estimationList[i].deleted_at != null) continue;

						if (estimationList[i].sparepart_type == "P") {
							let poDetails = listOfPO.find(
								(x) =>
									x.estimation_id == estimationList[i].id &&
									!x.next_purchase_order_item
							);
							if (poDetails) {
								estimationList[i].is_po = true;
								estimationList[i].is_used = poDetails.is_used;
								estimationList[i].is_arrived =
									poDetails.is_arrived;
								estimationList[i].time =
									poDetails.time_of_arrival;

								estimationList[i].is_used_date = poDetails.is_used_date
								estimationList[i].delivery_photo = poDetails.delivery_photo
							} else {
								estimationList[i].is_po = false;
							}
						}


						if(estimationList[i].sparepart_type == 'P' && !estimationList[i].is_approved_by_insurance){
							estimationList[i].price_modal = estimationList[i].price_per_item
							estimationList[i].price_per_item = estimationList[i].estimated_price ? estimationList[i].estimated_price : 0
							// estimationList[i].s
							estimationList[i].markup = 0
							continue;
						}
							
						else if (!estimationList[i].price_per_item) continue;


						if( typeof estimationList[i].is_approved_by_insurance == 'number' && estimationList[i].is_approved_by_insurance == 0 ) continue;

						if (
							estimationList[i].is_approved_by_insurance &&
							!estimationList[i].is_supplied_by_insurance &&
							estimationList[i].sparepart_type == "P"
						) {
							this.totalSparepartPurchasePrice += parseFloat(
								estimationList[i].price_per_item
							);
						}

						// console.log(estimationList[i].markup + 'markup' + estimationList[i].part_number + estimationList[i].price_per_item)

						

						// if(estimationList[i].is_approved_by_insurance == 1 && !estimationList[i].is_supplied_by_insurance) {
						let ppn = estimationList[i].ppn_included;

						// let supplierPrice = this.supplierPriceList[estimationList[i].id].supplier_prices.find(x => x.id == estimationList[i].supplier_price_id)
						let without_ppn = estimationList[i].without_ppn;
						estimationList[i].price_per_item = parseFloat(estimationList[i].price_per_item) 

						if (ppn == 1 && !without_ppn && estimationList[i].sparepart_type == 'J') {
							estimationList[i].price_per_item = parseFloat(
								estimationList[i].price_per_item / (1 + ppnPercentage)
							);
							// estimationList[i].price_per_item = parseFloat(
							// 	estimationList[i].price_per_item
							// );

							// let individual_ppn = (parseFloat(estimationList[i].price_per_item) *
							// 	parseFloat(estimationList[i].amount) - deductible) *
							// 	0.1;

							estimationList[i].individual_ppn = (parseFloat(estimationList[i].price_per_item) *
								parseFloat(estimationList[i].amount) - deductible) *
								ppnPercentage;

							// estimationList[i].price_per_item += individual_ppn
							

							
								ppnTotal +=  estimationList[i].individual_ppn
						}
						else if (estimationList[i].sparepart_type == 'J' && ppn == 0 && !without_ppn) {
							estimationList[i].individual_ppn = (parseFloat(estimationList[i].price_per_item) *
								parseFloat(estimationList[i].amount) - deductible) *
								ppnPercentage;

							ppnTotal +=  estimationList[i].individual_ppn

						}
						// else if (ppn == 0 && !without_ppn) {
						// 		let individual_ppn = (parseFloat(estimationList[i].price_per_item) *
						// 		parseFloat(estimationList[i].amount) - deductible) *
						// 		0.1;

						// 		estimationList[i].individual_ppn = (parseFloat(estimationList[i].price_per_item) *
						// 		parseFloat(estimationList[i].amount) - deductible) *
						// 		0.1;

						// 		estimationList[i].price_per_item += individual_ppn

								

								
						// }

						if(estimationList[i].ppn) {
							
							estimationList[i].individual_ppn = (estimationList[i].price_per_item  + parseFloat(estimationList[i].markup))* (1 - discountMult) * ppnPercentage
							console.log(estimationList[i].individual_ppn)

							ppnTotal +=  estimationList[i].individual_ppn * parseFloat(estimationList[i].amount)
						}
						// else {
						// 	estimationList[i].price_per_item = parseFloat(
						// 		estimationList[i].price_per_item
						// 	);
						// }

						// estimationList[i].price_per_item =
						// 	parseFloat(estimationList[i].price_per_item) +
						// 	parseFloat(
						// 		estimationList[i].markup
						// 			? estimationList[i].markup
						// 			: 0
						// 	);

						

						if(without_ppn) {
							discountPPN = discountPPN - deductible
						}




					}

					// alert(discountPPN)
					if (ppnTotal != 0)
						ppnTotal = Math.max(
							0,
							ppnTotal
						);
					this.estimationData.details.ppn = ppnTotal;
					// this.estimationData.details.ppn = 0;
				})
				.then(async () => {
					if (this.estimationData.details.insurance_id) {
						// console.log(
						// 	this.woDetail.asuransi,
						// 	this.estimationData.details.insurance_id
						// );
						this.insuranceDetails = this.woDetail.asuransi.find(
							(x) =>
								x.id == this.estimationData.details.insurance_id
						);

						this.insuranceDetails.tpl_cover = await this.getTPL()
					}

					this.insuranceCarList();
					this.getSupplierPrice();

					// console.log(this.estimationData.details.insuranceDetails)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		async getTPL () {
			try {
				let response = await this.$http.get('/api/v1/insurance/tpl/existing?form_destination=' + this.woDetail.work_order_id)
				// console.log(response)
				return response.data.data[0]
			}
			catch (e) {
				console.log(e)
			}
		},
		async removeTPL () {
			let id = this.insuranceDetails.tpl_cover.id

			this.$http.delete('/api/v1/insurance/tpl?id=' + id)
			.then((resp) => {
				this.getWoDetails()
				this.$store.dispatch('triggerAlert' , [true , 'Berhasil hapus TPL Asuransi pada work order ini.'])
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Error : Gagal Hapus TPL Asuransi'])
			})
		},
		loadPaymentList () {

			
			this.$http.get('/api/v1/workorder-estimation/'+ this.form_code +'/receipt')
			.then((resp) => {
				let listPayment = resp.data.data
				let dp = listPayment.filter(x => x.work_order_payment_type_id == 3)
				let dpTotal = 0

				if(dp.length > 0) {
					for(var i = 0 ; i < dp.length ; i++)
						dpTotal += parseFloat(dp[i].amount)
				}

				this.dp = dpTotal

				// if(this.dp) this.dp.amount = parseFloat(this.dp.amount)

				
			})
			.catch((err) => {
				console.log(err.response)
				let array = err.response.data.data.details.map(x => x.message)
				this.$store.dispatch('triggerAlert' , [false , array])
			})
		},
		getWoOtherCost () {
			this.$http.get('/api/v1/workorder-estimation/' + this.form_code + '/other-cost')
			.then((resp) => {
				let data = resp.data.data
				// console.log(data)

				let otherCost = 0

				data.forEach(row => {
					otherCost += row.price
				})

				this.otherCost = otherCost
				// for(var i = 0 ; i < data.length ; i++) {
				// 	let model = JSON.parse(JSON.stringify(this.modelExtraCost))
				// 	model.description = data[i].description
				// 	model.amount = data[i].price
				// 	model.id = data[i].id
				// 	this.form.extraCost.push(model)
				// }

				
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getWoLog() {
			this.$http
				.get("/api/v1/workorder/log/" + this.form_code)
				.then((resp) => {
					let woLog = resp.data.data;

					for (var i = 0; i < this.statusText.length; i++) {
						let value = woLog.find(
							(opt) => opt.log.name == this.statusText[i].name
						);
						this.statusText[i].value = value
							? this.statusText[i].name == "Janji Keluar"
								? value.finish_date
								: value.created_at
							: "-";

						// this.statusText[i].recent = 0
						if (value) {
							this.recentLog = this.statusText[i].name;
							// i > 0 ? this.statusText[i - 1].recent = 0 : null;
						}
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		async loadPendingEstimation (no_pol) {
			let response = await this.$http.get(`/api/v1/estimations/pending-estimation?search_param=${no_pol}&not_claim=1`)

			this.pending_estimation = response.data.data
		},
		getWoDetails() {
			this.$http
				.get(`/api/v1/workorder/${this.form_code}/detail`)
				.then(async (resp) => {
					var data = resp.data.data;
					let carDetail = this.$store.getters.getModelDetailById(
						data.customer_car ? data.customer_car.car_id : data.car_id
					);

					let spk = await this.getListOfSPKDocuments(this.form_code);

					let typeWo = data.serviceType ? data.serviceType : "-";
					let match = typeWo.match(/\b(\w)/g);
					typeWo = match ? match.join("") : "";

					

					let woDetail = {
						customer: data.customer,
						car: data.customer_car,
						work_order_id: this.form_code,
						show_wo: typeWo + this.form_code,
						nomor_mesin: data.customer_car ? data.customer_car.engine_number : '-',
						nomor_rangka: data.customer_car ? data.customer_car.chassis_number : '-',
						nomor_polisi: data.customer_car ? data.customer_car.registration : data.registration,
						asuransi: data.customer_car ? data.customer_car.insurance : [],
						kerusakan: data.condition ? this.evaluateDamage(data.condition.figure) : '-',
						tanggal_masuk: moment(data.created_at).format(
							"DD MMM YY HH:mm"
						),
						pelanggan: data.customer ? data.customer.name : 'Process Mobil',
						cso: data.CSO,
						merek: carDetail.brand_name,
						tipe: carDetail.name,
						image: data.condition && data.condition.imageList && data.condition.imageList[0] ? 
							data.condition.imageList[0] : 
						data.condition && data.condition.figureOverall && Array.isArray(
							data.condition.figureOverall.front.image
						)
							? data.condition.figureOverall.front.image[0]
							: null,
						address: data.customer ? data.customer.address : 'Process Mobil',
						warna: data.customer_car ? data.customer_car.car_color.name : '-',
						tahun: data.customer_car ? data.customer_car.year : '-',
						car_id: carDetail.brand_name,
						car_name: carDetail.name,
						spk_documents: spk,
						price: data.customer_car ? data.customer_car.price : 0,
						last_updated_price: data.customer_car ? data.customer_car.updated_at : '-',
					};

					if(!woDetail.price) {
						this.$swal({
							icon : 'info',
							title : 'Isi Harga Mobil',
							html : 'Mohon diisi harga mobil untuk melanjutkan process estimasi.'
						})
					}

					this.$set(this , 'woDetail' , woDetail)

					this.loadPendingEstimation(this.woDetail.nomor_polisi)

					// console.log(this.woDetail)
					this.woFull = data;

					// this.imagesList = await this.parseImages(data.condition.figureOverall, data.condition.figure)
				})
				.then(() => {
					this.getWoLog();

					this.loadEstimation();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		async getListOfSPKDocuments(form_code) {
			let response = await this.$http.get(
				`/api/v1/workorder-estimation/${form_code}/spk`
			);
			let data = response.data.data;

			return data;
		},
		evaluateDamage(figure) {
			var damages = "";
			for (var i in figure) {
				for (var j in figure[i]) {
					if (figure[i][j])
						damages += `${this.toCapitalizedWords(j)}, `;
				}
			}

			return damages ? damages.substring(0, damages.length - 2) : "-";
		},
	},
};
</script>

<style scoped>
.text-red {
	color : red;
}

.bg-date {
	background-color: rgb(190, 255, 233) !important;
}

.bg-lg-yellow {
	background-color: #ffc;
}

.wo-stats th {
	font-size: 16px;
}
.wo-stats td {
	padding-left: 20px;
}

.wo-listing-box {
	margin-top: 20px;
	border: 1px solid #4f4f4f;
	border-radius: 5px;
}
.wo-listing-box .listing-stats {
	font-size: 16px;
	margin: 0;
}
.wo-listing-box th {
	font-size: 16px;
	padding-right: 10px;
}

.clickAble:hover {
	cursor: pointer;
}
.vert-aligned {
	vertical-align: middle;
}

td {
	vertical-align: middle;
}

.redStatus {
	background-color: #fb9072;
}

.bg-red-opac {
	background-color: rgba(200, 200, 200, 0.2);
}

.bg-lg-blue {
	background-color : #e7f0f3;
}

.table td {
	border-top: 0px solid black;
}

.cancelled {
	-webkit-filter: blur(1px);
	-moz-filter: blur(1px);
	-o-filter: blur(1px);
	-ms-filter: blur(1px);
	filter: blur(1px);
	width: 100%;
	height: 100%;
	background-color: #ccc;
}

.flex-center {
	display : flex;
	justify-content: center;
	align-items: center;
}

.fa-chevron-left {
	cursor : pointer;
}

.fa-chevron-right {
	cursor : pointer;
}

.text-decor-line {
	text-decoration-line: underline;
	text-underline-offset: 6px;
}

.bahanTab:hover {
	background-color : #ffc;
}
</style>
